/**
 * Risale l'albero dal nodo dato fino al primo antenato realmente scrollabile in
 * verticale (`overflow-y` auto/scroll/overlay E `scrollHeight > clientHeight`).
 *
 * Serve agli elementi `position: sticky` che devono conoscere il proprio
 * contenitore di scroll per leggerne `scrollTop` / posizione (es. la barra-menu
 * dei titoli nei drawer densi, il cui scroll container è `.ant-drawer-body`).
 *
 * Ritorna `null` se nessun antenato scrolla (in quel caso il chiamante può
 * ricadere su `window`/`document.scrollingElement`).
 */
export function getScrollParent(node: Element | null): HTMLElement | null {
  if (typeof document === 'undefined') return null;

  let current = node?.parentElement ?? null;
  while (current) {
    const { overflowY } = getComputedStyle(current);
    const scrolls =
      (overflowY === 'auto' ||
        overflowY === 'scroll' ||
        overflowY === 'overlay') &&
      current.scrollHeight > current.clientHeight;
    if (scrolls) return current;
    current = current.parentElement;
  }

  return null;
}
